var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReviews = function SvgReviews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "14 14 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".reviews_svg__a_MPHN3TE8{fill:none}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "reviews_svg__a_MPHN3TE8",
    d: "M0 0h44v44H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "reviews_svg__a_MPHN3TE8",
    d: "M10 10h24v24H10z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.4 2H3.6A1.6 1.6 0 0 0 2 3.6V18l3.2-3.2h11.2a1.6 1.6 0 0 0 1.6-1.6V3.6A1.6 1.6 0 0 0 16.4 2M5.2 7.6h9.6v1.6H5.2m6.4 2.4H5.2V10h6.4m3.2-3.2H5.2V5.2h9.6",
    transform: "translate(12 12)",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgReviews;